export const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';
